/* __next_internal_client_entry_do_not_use__ DebugInfoSection auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { LazyDebugInfoSection } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/DebugInfo/LazyDebugInfoSection";
import { getUser } from "@faire/retailer-visitor-shared/serialized-data/getUser";
import React, { Suspense } from "react";
export var DebugInfoSection = function(param) {
    var _param_data = param.data, productToken = _param_data.productToken, promotedBy = _param_data.promotedBy, debugInfo = _param_data.debugInfo;
    // TODO: change to useUserStoreV2 when QueryClient is added to perf app
    var user = getUser();
    var isEmployee = !!(user === null || user === void 0 ? void 0 : user.is_employee);
    var isImpersonating = !!(user === null || user === void 0 ? void 0 : user.impersonating);
    if (!productToken) {
        return null;
    }
    if (!(isEmployee || isImpersonating)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(LazyDebugInfoSection, {
            productToken: productToken,
            promotedBy: promotedBy,
            debugInfo: debugInfo
        })
    });
};
